<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'initialization'"
    class="page"
  />

  <div
    v-else-if="page==='showing'"
    class="page"
  >
    <Header
      :setting="{
        title: '門診總表',
        hasCancelMethod: false,
      }"
      class="mb4"
    />
    <div
      v-for="schedulePicture in schedulePictures"
      :key="schedulePicture"
      @click="toDetail(schedulePicture)"
      class="bc--secondary border-radius-hot-dog pv3 mb4"
    >
      <div class="column--central">
        <div class=" fc--primary mv2">
          {{ schedulePicture.division }}
        </div>
      </div>
    </div>
  </div>

  <div
    v-else-if="page==='detail'"
    class="page"
  >
    <Header
      :setting="{
        title: '門診總表',
        hasCancelMethod: ($route.params.division === ''),
      }"
      @cancel="page='showing'"
      class="mb4"
    />
    <div class="row--central mb4">
      <div class="label label--secondary ">
        {{ choosenSchedulePicture.division }}
      </div>
    </div>
    <img
      :src="choosenSchedulePicture.url"
      alt=""
      class="image--size-x-fit mb5"
    >
    <div
      @click="browsePicture(choosenSchedulePicture.url)"
      class="label label--primary"
    >
      另開視窗查看門診表
    </div>
  </div>

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
  />
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import composable from '@/composable/index';
import spiderman from '@/spiderman/index';
import api from '@/api/index';

export default {
  setup() {
    const page = ref('initialization');
    const schedulePictures = ref([]);
    const choosenSchedulePicture = ref(null);
    const route = useRoute();
    const router = useRouter();

    onMounted(async () => {
      try {
        composable.loading.show('資料載入中');

        schedulePictures.value = await api.schedulePictures.get(
          composable.member,
        );

        page.value = 'showing';

        if (route.params.division !== '') {
          choosenSchedulePicture.value = schedulePictures.value.find(
            (picture) => picture.division === route.params.division,
          );
          page.value = 'detail';
        }
      } catch (error) {
        page.value = 'death';
        composable.death.show(error);
      } finally {
        composable.loading.close();
      }
    });

    function toDetail(schedulePicture) {
      choosenSchedulePicture.value = schedulePicture;
      page.value = 'detail';
    }

    function browsePicture(url) {
      const cmd = spiderman.generate.specialCommand({
        cmd: 'browse',
        url,
        timestamp: spiderman.generate.timestamp(),
      });
      router.replace(`${route.path}#inncom#${cmd}`);
    }

    return {
      page,
      composable,
      schedulePictures,
      toDetail,
      choosenSchedulePicture,
      browsePicture,
    };
  },
};
</script>
